import { render, staticRenderFns } from "./_invoices.vue?vue&type=template&id=546e1c85"
import script from "./_invoices.vue?vue&type=script&lang=js"
export * from "./_invoices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports